// Golden frames for top-badge creators (mirrors backend/milestones.py FRAME_TIERS)
export const FRAME_STYLES = {
  gold: {
    label: "1K Club",
    ring: "ring-2 ring-jam-gold/80",
    border: "border-jam-gold/70",
    glow: "shadow-[0_0_14px_rgba(254,209,0,0.35)]",
    text: "text-jam-gold",
    bg: "bg-gradient-to-r from-jam-gold/15 via-amber-300/10 to-jam-gold/15",
  },
  diamond: {
    label: "Crowd Favorite",
    ring: "ring-2 ring-amber-300",
    border: "border-amber-300/80",
    glow: "shadow-[0_0_18px_rgba(252,211,77,0.5)]",
    text: "text-amber-200",
    bg: "bg-gradient-to-r from-jam-gold/25 via-amber-200/15 to-jam-gold/25",
  },
  legend: {
    label: "10K Legend",
    ring: "ring-[3px] ring-jam-gold",
    border: "border-jam-gold",
    glow: "shadow-[0_0_24px_rgba(254,209,0,0.7)] animate-pulse-gold",
    text: "text-jam-gold",
    bg: "bg-gradient-to-r from-jam-gold/35 via-amber-200/25 to-jam-gold/35",
  },
};

export const frameStyle = (frame) => (frame && FRAME_STYLES[frame]) || null;
